var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pl-0 pr-0",staticStyle:{"max-width":"450px"},attrs:{"fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }